import {
  disp_add_form
} from "../common/ui"

$(function () {

  disp_add_form(".plus",".form-temp","#form_area")

});